import React, { useEffect, useRef, useState } from "react";
import { Flex, Form, Input, Spin } from "antd";
import { IoMdSend } from "react-icons/io";
import {
  countUnreadMessagesByPatient,
  listenForDoctorsList,
  listenForMessages,
  listenUnreadMessagesByPatient,
  markMessagesAsSeen,
  sendMessage,
} from "../../Services/chatService";
import UserService from "../../Services/UserService";
import doctorIcon from "../../assets/images/Svg/doctorIcon.svg";
import dayjs from "dayjs";
import { IoChevronBackOutline } from "react-icons/io5";
import { IoArrowBack } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { DECREASECOUNT } from "../../Redux/actions/ChatActions";
import { CiCirclePlus } from "react-icons/ci";
import { ImAttachment } from "react-icons/im";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar";
import threeDotIcon from "../../assets/images/Svg/three_dot_icon.svg";
import backArrow from "../../assets/images/Svg/backArrow.svg";

dayjs.extend(relativeTime);
dayjs.extend(calendar);

function LiveChat({ handleClose, chatOpen }) {
  const [patientIdList, setPatientIdList] = useState([]);
  const [messages, setMessages] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [conversedUserIds, setConversedUserIds] = useState([]);
  const [conversedUsersList, setConversedUsersList] = useState([]);
  const [currConversedUserList, setCurrConversedUserList] = useState([]);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [chatScreenEnable, setChatScreenEnable] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [enterBtnClicked, setEnterBtnClicked] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState({});
  const [allDocView, setAllDocView] = useState(false);
  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const unsubscribeRef = useRef(null);
  const chatContainerRef = useRef(null);
  const msgRef = useRef();
  const dispatch = useDispatch();
  const totalMsgCount = useSelector((state) => state.chatCount.count);

  const getUsersList = async (filterVal) => {
    setIsLoading(true);
    const userPayload = { displayInWebsite: "Y", status: 1 };
    let finalPayload;

    if (filterVal) {
      finalPayload = {
        ...userPayload,
        ...filterVal
      }
    }

    try {
      const response = await UserService.getUser(filterVal ? finalPayload : userPayload);
      setDoctors(response?.data || []);
      setIsLoading(false);
    }
    catch (e) {
      console.error(e);
      setIsLoading(false);
    }


  };

  useEffect(() => {

    getUsersList(null);
    const unsubscribe = listenForDoctorsList(
      patObj.patientId,
      setConversedUserIds
    );

    return () => unsubscribe();
  }, [patObj.patientId]);

  useEffect(() => {
    const fetchAllConvUsers = async () => {
      const userArr = [];
      for (let docId of conversedUserIds) {
        const docRes = await getDoctorsList({ userId: docId });
        if (docRes && docRes?.length > 0) userArr.push(docRes[0]);
      }
      setFilteredDoctors(userArr);
    };
    fetchAllConvUsers();
  }, [conversedUserIds]);

  useEffect(() => {
    if (filteredDoctors.length > 0 && conversedUserIds.length > 0) {
      const filtered = filteredDoctors.filter((doc) =>
        conversedUserIds.includes(doc.userId)
      );
      setConversedUsersList(filtered);
      setCurrConversedUserList(filtered);
    }
  }, [conversedUserIds, filteredDoctors]);

  useEffect(() => {
    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
      }
    };
  }, []);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    if (!patObj.patientId) return;

    const unsubscribe = listenUnreadMessagesByPatient(
      patObj.patientId,
      (counts) => setUnreadCounts(counts)
    );

    return () => unsubscribe();
  }, [patObj?.patientId]);

  const getDoctorsList = async (filterPayload) => {
    const userPayload = { ...filterPayload, status: 1 };
    setIsLoading(true);
    try {
      const response = await UserService.getDoctors(userPayload);
      const filterDoctors = response?.data?.filter(
        (item) => item.userType === "P" && item.videoFee && item.videoFee > 0
      );
      setIsLoading(false);
      return filterDoctors;
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  const handleSelectChat = async (doc) => {
    setSelectedDoctor(doc);
    setMessages([]);
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
    }
    markMessagesAsSeen(patObj.patientId, doc.userId);
    // const msgCount = countUnreadMessages(patObj.patientId);
    const counts = await countUnreadMessagesByPatient(patObj.patientId);
    let totalUnreadCount = 0;
    for (let key in counts) {
      totalUnreadCount += counts[key];
    }
    dispatch({ type: DECREASECOUNT, payload: totalUnreadCount });
    unsubscribeRef.current = listenForMessages(
      patObj.patientId,
      doc.userId,
      setMessages
    );
    setChatScreenEnable(true);
    setAllDocView(false);
  };

  const handleBack = async () => {
    markMessagesAsSeen(patObj.patientId, selectedDoctor.userId);
    const counts = await countUnreadMessagesByPatient(patObj.patientId);
    let totalUnreadCount = 0;
    for (let key in counts) {
      totalUnreadCount += counts[key];
    }
    dispatch({ type: DECREASECOUNT, payload: totalUnreadCount });
    // await fetchUnreadCounts();
    setChatScreenEnable(false);
    setSelectedDoctor(null);
  };

  const handleSend = async () => {
    if (message.trim()) {
      try {
        await sendMessage(patObj.patientId, selectedDoctor.userId, message);
        msgRef.current.resetFields();
        setMessage("");
        setEnterBtnClicked(false);
        listenForMessages(selectedDoctor.userId, patObj.patientId, setMessages);
      } catch (error) {
        console.error("Error sending message:", error);
      }
    }
  };

  const handleMsgSend = (event) => {
    if (event.key === "Enter" && !enterBtnClicked) {
      setEnterBtnClicked(true);
      handleSend();
    }
  };

  const handleAllDocListView = () => {
    setAllDocView(!allDocView);
  };

  const handleContBack = () => {
    setAllDocView(false);
  };

  const handleConversedSearch = (e) => {
    const searchKey = e.target.value;
    if (!searchKey) {
      setCurrConversedUserList(conversedUsersList);
      return;
    }
    const filtered = conversedUsersList?.filter((item) =>
      item.firstName.includes(searchKey)
    );
    setCurrConversedUserList(filtered);
  };

  const handleUserSearch = async (e) => {
    const value = e.target.value;
    if (value && value.length >= 2) {
      const payload = {
        userName: value
      }
      await getUsersList(payload);
    }
    else {
      await getUsersList(null);
    }
  }

  return (
    <div>
      {!chatScreenEnable && !allDocView && (
        <div className="w-full max-w-sm mx-auto bg-white shadow-lg rounded-lg">
          <div className="flex items-center p-4 border-b">
            <button
              className="text-gray-500 cursor-pointer"
              onClick={handleAllDocListView}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
            <input
              type="text"
              placeholder="Search"
              className="ml-4 flex-1 px-4 py-2 rounded-full bg-gray-100 outline-none"
              onChange={handleConversedSearch}
            />
          </div>

          <div className="">
            {isLoading && currConversedUserList.length === 0 ? (
              <div className="h-screen flex items-center justify-center">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : !isLoading && currConversedUserList.length === 0 ? (
              <div className="h-screen flex flex-col gap-1 justify-center items-center">
                <p className="text-lg font-light">No conversations.</p>
              </div>
            ) : (
              currConversedUserList.map((doc, index) => (
                <div
                  key={index}
                  className="flex items-center border-b p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSelectChat(doc)}
                >
                  {doc.imageName ? (
                    <img
                      src={process.env.REACT_APP_IMAGE_URL + doc.imageName}
                      alt={doc?.firstName}
                      className="w-12 h-12 rounded-full"
                    />
                  ) : (
                    <img
                      src={doctorIcon}
                      alt={doc?.userName}
                      className="w-12 h-12 rounded-full"
                    />
                  )}
                  <div className="ml-4 flex-1">
                    <div className="flex justify-between items-center">
                      <h3 className="font-semibold flex items-center">
                        {doc?.firstName}
                      </h3>
                      {unreadCounts[doc.userId] > 0 && (
                        <div className="flex items-center justify-center">
                          <span className="w-5 h-5 rounded-[50%] bg-dangerColor text-white text-center">
                            {unreadCounts[doc.userId]}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}

      {selectedDoctor && chatScreenEnable && !allDocView && (
        <div className="flex flex-col h-screen border rounded-md">
          <div className="bg-[#FFFFFF] text-[#333333] h-14 px-1 py-1.5  flex justify-between items-center">
            <div className="h-[inherit] flex items-center gap-3">
              <img
                src={backArrow}
                className="font-medium text-xl text-[#333333] mx-2 cursor-pointer"
                alt="Back Arrow"
                onClick={handleBack}
              />
              <div className="w-10 h-10 rounded-full flex items-center">
                {selectedDoctor.imageName ? (
                  <img
                    src={
                      process.env.REACT_APP_IMAGE_URL + selectedDoctor.imageName
                    }
                    alt={selectedDoctor?.firstName}
                    className="w-10 h-10 rounded-full"
                  />
                ) : (
                  <img
                    src={doctorIcon}
                    alt={selectedDoctor?.userName}
                    className="w-10 h-10 rounded-full"
                  />
                )}
              </div>
              <div>
                <p className="font-medium text-base font-roboto">
                  {selectedDoctor?.firstName}
                </p>
              </div>
            </div>
            <img
              src={threeDotIcon}
              className="font-medium text-xl text-[#333333] mx-2 cursor-pointer"
              alt="Three dots"
            />
          </div>

          <div
            ref={chatContainerRef}
            className="h-[85%] hideScrollBar px-2 bg-[#F0F2F1]"
          >
            {messages &&
              messages
                ?.sort(
                  (a, b) => a.timestamp?.toMillis() - b.timestamp?.toMillis()
                )
                .reduce((acc, msg, index, arr) => {
                  const messageDate = dayjs(msg.timestamp?.toDate()).format(
                    "DD/MM/YYYY"
                  );
                  const prevMessageDate =
                    index > 0
                      ? dayjs(arr[index - 1].timestamp?.toDate()).format(
                        "DD/MM/YYYY"
                      )
                      : null;

                  // Add date separator if it's a new date
                  if (messageDate !== prevMessageDate) {
                    acc.push(
                      <div
                        key={`date-${messageDate}`}
                        className="text-center text-xs text-gray-500 my-2"
                      >
                        {dayjs(msg.timestamp?.toDate()).calendar(null, {
                          sameDay: "[Today]",
                          lastDay: "[Yesterday]",
                          lastWeek: "dddd",
                          sameElse: "DD/MM/YYYY",
                        })}
                      </div>
                    );
                  }

                  acc.push(
                    <div
                      key={msg.id}
                      className="w-full flex items-center justify-between"
                    >
                      {msg.senderID === patObj.patientId ? (
                        <div className="max-w-64 my-0.5 relative p-1 text-slate-800 bg-[#CDEBEA] border rounded-l-lg rounded-br-lg ml-auto">
                          {msg.text}
                          <div className="flex justify-end">
                            <span className="text-[8px]">
                              {dayjs(msg.timestamp?.toDate()).format("hh:mm A")}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="max-w-64 my-0.5 relative p-1 text-slate-800 bg-[#FFFFFF] border rounded-r-lg rounded-bl-lg mr-auto">
                          {msg.text}
                          <div className="flex justify-end">
                            <span className="text-[8px]">
                              {dayjs(msg.timestamp?.toDate()).format("hh:mm A")}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  );

                  return acc;
                }, [])}
          </div>

          <Form ref={msgRef}>
            <div className="w-full flex items-center gap-2 p-2">
              <div className="w-[90%]">
                <Form.Item name="textMsg" className="m-0 p-0">
                  <input
                    type="text"
                    className="border rounded-3xl outline-none w-full py-2 text-xs px-2 font-medium"
                    placeholder="Type message..."
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyDown={handleMsgSend}
                  />
                </Form.Item>
              </div>
              {message && message.length > 0 ? (
                <div className="w-[10%]">
                  <div
                    onClick={handleSend}
                    className="w-7 h-7 rounded-full bg-[#189FAA] flex items-center justify-center cursor-pointer"
                  >
                    <IoMdSend className="w-5 h-5 text-white" />
                  </div>
                </div>
              ) : (
                <div className="w-[10%]">
                  <div className="w-7 h-7 rounded-full bg-[#189FAA] flex items-center justify-center cursor-pointer">
                    <ImAttachment className="w-5 h-5 text-white rotate-45" />
                  </div>
                </div>
              )}
            </div>
          </Form>
        </div>
      )}

      {allDocView && (
        <>
          <div className="flex gap-1 items-center p-4 border-b">
            <IoArrowBack
              className="font-medium w-6 h-6 text-iconBlue mx-2 cursor-pointer"
              onClick={handleContBack}
            />
            <Input
              type="text"
              placeholder="Search"
              className="flex-1 px-4 py-2 rounded-full bg-gray-100 outline-none"
              onChange={handleUserSearch}
            />
          </div>
          <div className="">
            {isLoading && doctors.length === 0 ? (
              <div className="h-screen flex items-center justify-center">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : (
              doctors.map((doc, index) => (
                <div
                  key={index}
                  className="flex items-center border-b p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSelectChat(doc)}
                >
                  {doc.imageName ? (
                    <img
                      src={process.env.REACT_APP_IMAGE_URL + doc.imageName}
                      alt={doc?.firstName}
                      className="w-12 h-12 rounded-full"
                    />
                  ) : (
                    <img
                      src={doctorIcon}
                      alt={doc?.userName}
                      className="w-12 h-12 rounded-full"
                    />
                  )}
                  <div className="ml-4 flex-1">
                    <div className="flex justify-between items-center">
                      <h3 className="font-semibold flex items-center">
                        {doc?.firstName}
                      </h3>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default LiveChat;
